/* eslint-disable no-irregular-whitespace */
import dynamic from 'next/dynamic'
import Meta from 'components/meta/meta'
import PageTitle from 'components/page-title/page-title'
import Bread from 'components/bread/bread'
import Faqs from 'components/faqs/faqs'
import PageHead from 'components/page-head/page-head'
import PageFoot from 'components/page-foot/page-foot'
import { getData } from 'utils/api'

const Products = dynamic(() => import('components/hits/products'))

export default function Page(category) {
    let description = `Prekės pagal kategoriją - ${category.name}.`
    //
    if (category.meta_description) {
        description = category.meta_description
    } else if (category.description) {
        description = category.description
    }

    let bottomDescription = category.long_description
    if (!bottomDescription && category.filter && category.description) {
        bottomDescription = category.description
    }

    let def = category?.default?.trim()
    //  "﻿Aksesuarai > Pirštinės" //category.default
    let filter = category?.filter?.replace(/AND/g, '&&').trim().replace(/﻿/g,"")
    //  "hierarchical_taxonomies.lvl0:Aksesuarai && hierarchical_taxonomies.lvl1:Aksesuarai > Pirštinės" //  category.filter
    // defaultRefinement

    return (
        <>
            <Meta title={category.name} description={description} />
            {category.description ? (
                <PageHead title={category.name} description={category.description}>
                    <Bread items={category.path} small={1} className="mb12" />
                </PageHead>
            ) : (
                <>
                    <Bread items={category.path} small={1} className="mb12" />
                    <PageTitle>{category.name}</PageTitle>
                </>
            )}
            {category.filter && <Products defaultRefinement={def} filter={filter} />}
            {bottomDescription && <PageFoot>{bottomDescription}</PageFoot>}
            {!!category.faqs?.length && <Faqs items={category.faqs} />}
        </>
    )
}

export async function getStaticProps(context) {
    const data = await getData(`taxonomy/${context.params.params.join(',')}`)
    if (data.props && data.props.redirect) {
        return {
            redirect: {
                destination: data.props.redirect
            }
        }
    }
    return data
}

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: true
    }
}
